import { useFormikContext } from 'formik';

import { type RegistrationFormContext } from 'hb-react/shared/apps/Events/pages/Booking/pages/Registration';

export const useForm = () => useFormikContext<RegistrationFormContext>();
